import { useMemo, useState } from "react";
import PayrollCompanyLayout from "../../../components/layouts/PayrollCompanyLayout";
import SalaryAdvanceView from "./views/SalaryAdvanceView";
import PartialSalaryView from "./views/PartialSalaryView";
import { Helmet } from "react-helmet-async";
import useUserStore from "../../../state-management/useUserStore";
import HumanResourceLayout from "../../../components/layouts/HumanResourceLayout";
import { useSearchParams } from "react-router-dom";
import CustomTab from "../../../components/custom_tab/CustomTab";
import { PayAdvancesTabColumns } from "../../../components/custom_tab/tabColumns";
import { PERMISSIONS, useValidateUserPermissions } from "../../../helpers/usePermissionManager";

const PayAdvances = () => {
	useValidateUserPermissions([PERMISSIONS.SALARY_READ, PERMISSIONS.SALARY_WRITE], "OR");
	const { userType } = useUserStore();
	const LAYOUT = useMemo(() => {
		switch(userType) {
			case "ORGANIZATION": 
				return PayrollCompanyLayout;
			default: 
				return HumanResourceLayout;
		}
	}, [userType])
	const [searchParams] = useSearchParams();
	const [view, setView] = useState(
		searchParams.get("view") || "salaryAdvance"
	);

	return (
		<LAYOUT>
			<Helmet>
				<title>Pay Advances |{userType === "HR" ? " HR " : " Company "}Flow</title>
			</Helmet>
			<h1 className="font-bold text-xl mb-8">Pay Advances</h1>
			<CustomTab
				view={view}
				setView={setView}
				tabColumns={PayAdvancesTabColumns}
			>
				{view === "salaryAdvance" && <SalaryAdvanceView />}
				{view === "partialSalary" && <PartialSalaryView />}
			</CustomTab>
		</LAYOUT>
	);
};

export default PayAdvances;
